/** Bed rules (pure): can the player sleep now? */
export type BedVerdict = 'ok' | 'monsters' | 'day' | 'explode';

export interface BedCtx {
  dimension: 'overworld' | 'nether' | 'end' | string;
  /** sky.time: 0 = dawn, 0.5 = dusk, 0.75 = midnight. */
  time: number;
  thundering: boolean;
  /** Positions of live hostile mobs. */
  hostiles: ReadonlyArray<{ x: number; y: number; z: number }>;
  px: number; py: number; pz: number;
}

export const BED_MESSAGES = {
  monsters: 'You may not rest now; there are monsters nearby',
  day: 'You can only sleep at night or during thunderstorms',
} as const;

export function bedVerdict(c: BedCtx): BedVerdict {
  if (c.dimension !== 'overworld') return 'explode';
  if (!(c.time > 0.52) && !c.thundering) return 'day';
  for (const h of c.hostiles) {
    if (Math.abs(h.x - c.px) <= 8 && Math.abs(h.z - c.pz) <= 8 && Math.abs(h.y - c.py) <= 5) return 'monsters';
  }
  return 'ok';
}
